'use client';

import { __styles, mergeClasses } from "@griffel/react";
import { tokens } from "@fluentui/react-theme";
export const accordionPanelClassNames = {
  root: 'fui-AccordionPanel'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    jrapky: 0,
    Frg6f3: 0,
    t21cq0: 0,
    B6of3ja: 0,
    B74szlk: "f1axvtxu"
  }
}, {
  d: [[".f1axvtxu{margin:0 var(--spacingHorizontalM);}", {
    p: -1
  }]]
});
/** Applies style classnames to slots */
export const useAccordionPanelStyles_unstable = state => {
  const styles = useStyles();
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(accordionPanelClassNames.root, styles.root, state.root.className);
  return state;
};